<template lang="pug">
  Popup(:visible="visible" :position="'bottom'" @close="handleClose" mask-closable)
    //- 签到引导图片（首次展示，永久疲劳度）
    img.guide-img(
      v-if="showGuide"
      src="https://m.hellobike.com/9e9041b2_Frame%202117131555%20(1).png"
      alt="请点击下方按钮，立即签到"
    )
    .popup-content(@click.stop :class="{ 'is-mini-tab': isMiniTab }")
      //- 关闭按钮
      .close-btn(@click="handleClose")

      //- 标题区域
      .header
        img.title-img(
          v-if="extInfo.titleIcon"
          :src="extInfo.titleIcon"
          alt="连签领奖励金"
        )
        .subtitle(v-if="extInfo.title") {{ extInfo.title }}

      .reward-block
        .tag-label {{ didSignToday ? '明天签到可领' : '今天签到可领' }}
        .reward-info
          img.coin(
            src="https://m.hellobike.com/55f475bbae.png"
            alt=""
          )
          .num
            .amount {{ rewardAmount }}
            span.unit 奖励金
        //- 只在支付宝小程序中展示
        .extra(v-if="isAlipayMini" @click="handleRewardLinkClick")
          img.multiply-bg(
            v-if="extra.appMultiplyImage"
            :src="extra.appMultiplyImage"
            alt="APP翻倍"
          )
          template(v-if="extra.appSignRewardText")
            a.link {{ extra.appSignRewardText }}
            icon.icon(icon="jiantou-right" color="#a5725b")
        //- 签到计划卡片
        .plan
          SignInCardPlan(:signPlanList="signPlanList")

      //- 签到按钮
      .sign-btn(
        :class="{ signed: didSignToday }"
        @click="handleSignBtnClick"
      )
        span {{ extInfo.signBtnText || '我知道了' }}
</template>

<script>
import SPM from '@/pages/welfare/common/spm';
import { env } from '@hb/NBridge/lib/h5';
import { Popup, Icon } from '@hb/platformui-h5';
import { jumpUrl } from '@/utils/tools';
import SignInCardPlan from './sign-in-card-plan';

export default {
  name: 'SignInPopup',
  components: { SignInCardPlan, Popup, Icon },
  props: {
    visible: { type: Boolean, default: false },
    signPlanList: { type: Array, default: () => [] },
    extInfo: { type: Object, default: () => ({}) },
    showGuide: { type: Boolean, default: false },
    // 签到广告信息，用于判断是否有广告
    signInAdInfo: { type: Object, default: () => null },
  },
  computed: {
    // 今日是否已签到
    didSignToday() {
      return !!this.extInfo.didSignToday;
    },
    // 签到可领奖励金（根据签到状态切换今日/明日）
    rewardAmount() {
      const { bountyCountToday = 0, bountyCountTomorrow = 0 } = this.extInfo;
      return this.didSignToday ? bountyCountTomorrow : bountyCountToday;
    },
    // 是否小程序tab页
    isMiniTab() {
      return this.$route.query.isMiniTab === '1';
    },
    // app额外信息
    extra() {
      return this.extInfo.extraConfig || {};
    },
    // 是否支付宝小程序
    isAlipayMini() {
      return env.isAliMP || env.isAliMPMonitor;
    },
    // 已连签天数（从 extInfo.title 中解析，如"已连签3天"）
    signupDays() {
      const { title = '' } = this.extInfo;
      const match = title.match(/连签(\d+)天/);
      return match ? match[1] : '0';
    },
    // 是否有广告
    hasAd() {
      if (!this.signInAdInfo) return false;
      const { bannerAdvertisementUnitId = '' } = this.signInAdInfo;
      return !!bannerAdvertisementUnitId;
    },
    // adv 标识：'0' 有广告, '1' 无广告
    adv() {
      return this.hasAd ? '0' : '1';
    },
    // 奖励金数量
    bonusAmount() {
      return String(this.rewardAmount || '');
    },
  },
  watch: {
    // 监听弹窗可见性变化，触发曝光埋点
    visible(val) {
      if (val) {
        this.trackPopupExpose();
      }
    },
  },
  methods: {
    // 弹窗可见时触发所有相关曝光埋点
    trackPopupExpose() {
      // 手动签到弹窗曝光
      SPM.moduleExpose({
        moduleId: 'platform_manualSignIn',
        contentId: 'platform_manualSignIn',
        businessInfo: {
          checkinStatus: this.didSignToday ? '1' : '0',
          signupDays: this.signupDays,
          adv: this.adv,
        },
      });

      // 明日再来曝光
      if (this.didSignToday) {
        SPM.moduleExpose({
          moduleId: 'platform_tomorrowCome',
          contentId: 'platform_tomorrowCome',
          businessInfo: {},
        });
      }

      // 跨端签到标识曝光
      if (this.isAlipayMini && this.extra.appSignRewardText) {
        SPM.moduleExpose({
          moduleId: 'platform_convertPort',
          contentId: 'platform_convertPort',
          businessInfo: {
            bonusAmount: this.bonusAmount,
          },
        });
      }

      // 小哈 tips 曝光
      if (this.showGuide) {
        SPM.moduleExpose({
          moduleId: 'platform_popupTips',
          contentId: 'platform_popupTips',
          businessInfo: {},
        });
      }
    },


    handleSignBtnClick() {
      if (this.didSignToday) return;
      SPM.clickButton({
        buttonName: 'platform_popupSignIn',
        businessInfo: {
          adv: this.adv,
          bonusAmount: this.bonusAmount,
        },
      });
      this.$emit('sign');
    },
    handleRewardLinkClick() {
      SPM.clickButton({
        buttonName: 'platform_convertPort',
        businessInfo: {
          bonusAmount: this.bonusAmount,
        },
      });
      const link = this.extra.leadChangePortLink;
      if (link) {
        jumpUrl(link);
      }
    },
    handleClose() {
      SPM.clickButton({
        buttonName: 'platform_manualSignupClose',
        businessInfo: {
          adv: this.adv,
          signupDays: this.signupDays,
        },
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
@plan-bg: 'https://m.hellobike.com/eef22041_Union%20%281%29.png';

.guide-img {
  display: block;
  width: 2.79rem;
  transform: translateY(0.15rem);
}

.popup-content {
  position: relative;
  width: 100%;
  z-index: 1;
  background: linear-gradient(0deg, #f0f3f5 59%, #fff2c6 100%);
  border-radius: 0.24rem 0.24rem 0 0;
  padding: 0.16rem;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 0.16rem);
  padding-bottom: calc(env(safe-area-inset-bottom) + 0.16rem);

  &.is-mini-tab {
    padding-bottom: 0.9rem;
  }

  .close-btn {
    width: 0.16rem;
    height: 0.16rem;
    position: absolute;
    right: 0.16rem;
    top: 0.16rem;
    background:
      url(https://m.hellobike.com/1a207d93ec.png)
      no-repeat center / 100%;
    z-index: 5;
  }

  .header {
    margin-bottom: 0.16rem;

    .title-img {
      height: 0.27rem;
    }

    .subtitle {
      font-size: 0.14rem;
      color: #927c6e;
      margin-top: 0.08rem;
      line-height: 0.12rem;
    }
  }

  .reward-block {
    background: #fff;
    border-radius: 0.12rem;
    padding: 0 0.16rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-bottom: 0.2rem;

    .tag-label {
      position: absolute;
      top: 0;
      left: 0;
      background: linear-gradient(127deg, #fff5be 4%, #f9e488 100%);
      border-radius: 0.12rem 0 0.12rem 0;
      padding: 0.08rem 0.13rem;
      font-size: 0.14rem;
      font-weight: 500;
      color: #000;
      line-height: 0.12rem;
    }

    .reward-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 0.12rem;
      margin-bottom: 0.06rem;

      .coin {
        width: 0.54rem;
        height: 0.38rem;
      }

      .num {
        display: flex;
        align-items: baseline;

        .amount {
          font-family: 'DIN Alternate', sans-serif;
          font-size: 0.32rem;
          font-weight: 700;
          color: #ff3e36;
          line-height: 1em;
        }

        .unit {
          font-size: 0.16rem;
          color: #ff3e36;
          font-weight: 600;
        }
      }
    }

    .extra {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 0.07rem;
      height: 0.17rem;

      .multiply-bg {
        position: absolute;
        left: 0;
        top: 0;
        height: 0.17rem;
        width: auto;
      }

      .link {
        position: relative;
        font-size: 0.11rem;
        color: #a5725b;
        line-height: 0.17rem;
        margin-left: 0.63rem;
      }

      .icon {
        position: relative;
        margin-left: -0.02rem;
      }
    }

    .plan {
      width: calc(100% + 0.32rem);
      margin: 0 -0.16rem;
      height: 1.05rem;
      background: url(@plan-bg) no-repeat center / 100% 100%;
      padding: 0.18rem 0.06rem 0.06rem;
      box-sizing: border-box;
    }
  }

  .sign-btn {
    background: linear-gradient(90deg, #ff5523, #ff3e36);
    color: #fff;
    font-size: 0.16rem;
    font-weight: 600;
    border-radius: 0.88rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 0.5rem;

    &.signed {
      background: linear-gradient(90deg, #ff9d8a, #ff8a82);
    }
  }
}
</style>
